import { kanziSections } from "../../../../content/kanziSections";
import Reveal from "../../Reveal";
import SectionHeading from "../../SectionHeading";
import SpotlightCard from "../../SpotlightCard";
import Badge from "../../../Badge";

const LeadGenVisual = ({ visual }) => (
  <div className="kanzi-scene-visual kanzi-scene-visual--lead">
    <div className="kanzi-scene-stats-grid">
      {visual.stats.map((stat) => (
        <div key={stat.label} className="kanzi-scene-stat">
          <span className="kanzi-scene-stat__value">{stat.value}</span>
          <span className="kanzi-scene-stat__label">{stat.label}</span>
        </div>
      ))}
    </div>
    <div className="kanzi-scene-insight">
      <div className="kanzi-scene-insight__dot" />
      <span>{visual.insight}</span>
    </div>
  </div>
);

const OpsVisual = ({ visual }) => (
  <div className="kanzi-scene-visual kanzi-scene-visual--ops">
    <div className="kanzi-scene-ops-headline">
      <span className="kanzi-scene-ops-headline__value">{visual.headline}</span>
      <span className="kanzi-scene-ops-headline__label">{visual.headlineLabel}</span>
    </div>
    <div className="kanzi-scene-rows">
      {visual.rows.map((row) => (
        <div key={row.label} className="kanzi-scene-row">
          <span className="kanzi-scene-row__label">{row.label}</span>
          <span className="kanzi-scene-row__status kanzi-scene-row__status--active">
            {row.status}
          </span>
        </div>
      ))}
    </div>
  </div>
);

const RcmVisual = ({ visual }) => (
  <div className="kanzi-scene-visual kanzi-scene-visual--rcm">
    <div className="kanzi-scene-signal">
      <div className="kanzi-scene-signal__pulse" />
      <span className="kanzi-scene-signal__badge">{visual.badge}</span>
    </div>
    <div className="kanzi-scene-rows">
      {visual.rows.map((row) => (
        <div key={row.label} className="kanzi-scene-row">
          <span className="kanzi-scene-row__label">{row.label}</span>
          <span className="kanzi-scene-row__value">{row.value}</span>
        </div>
      ))}
    </div>
    <p className="kanzi-scene-note">{visual.note}</p>
  </div>
);

const SceneVisual = ({ visual }) => {
  if (visual.type === "lead-gen") return <LeadGenVisual visual={visual} />;
  if (visual.type === "operations") return <OpsVisual visual={visual} />;
  if (visual.type === "rcm") return <RcmVisual visual={visual} />;
  return null;
};

const Scenes = () => (
  <section id="scenes" className="section-block">
    <div className="section-shell">
      <SectionHeading
        eyebrow={kanziSections.scenes.eyebrow}
        title={kanziSections.scenes.title}
      />

      <div className="kanzi-scenes-list">
        {kanziSections.scenes.items.map((scene, index) => (
          <Reveal key={scene.number} variant={index % 2 === 0 ? "fade-right" : "fade-left"}>
            <SpotlightCard className="glass-panel kanzi-scene-card">
              <div className="kanzi-scene-card__inner">
                <div className="kanzi-scene-card__text">
                  <div className="kanzi-scene-card__meta">
                    <Badge className="kanzi-scene-card__category">{scene.category}</Badge>
                  </div>
                  <h3 className="kanzi-scene-card__title">{scene.title}</h3>
                  <div className="kanzi-scene-card__narrative">
                    {scene.narrative.map((paragraph, i) => (
                      <p key={i}>{paragraph}</p>
                    ))}
                  </div>
                </div>
                <div className="kanzi-scene-card__visual">
                  <SceneVisual visual={scene.visual} />
                </div>
              </div>
            </SpotlightCard>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Scenes;
